$(document).ready(function () {
  // Function to calculate and set dynamic max-height for side cart items
  function updateSideCartMaxHeight() {
    const headerHeight = $(".side-cart-header").outerHeight() || 0;
    const footerHeight = $(".side-cart-footer-wrap").outerHeight() || 0;
    const totalHeight = headerHeight + footerHeight;
    const dynamicMaxHeight = `calc(100vh - ${totalHeight}px)`;

    $(".side-cart-item-wrap").css("max-height", dynamicMaxHeight);
  }

  // Function to update cart title count
  function updateCartTitleCount(itemCount) {
    // Ensure itemCount is a valid number, default to 0 if NaN or invalid
    var count = isNaN(itemCount) || itemCount == null ? 0 : parseInt(itemCount);
    $(".cart-title-count").text(count);
  }

  $(".site-header__cart").on("click", function () {
    $(".side-cart-main-wrap").toggleClass("open-side-cart");
    $(".side-cart-main-wrap").parent().toggleClass("open-side-cart");
    $("body").toggleClass("open-side-cart");

    // Update max-height when cart opens
    setTimeout(updateSideCartMaxHeight, 100);

    // Ensure cart title count is synced when cart opens
    setTimeout(function () {
      fetchCart(); // This will update the cart title count
    }, 50);
  });
  $(".side-cart-overly-wrap, .close-icon-wrap").on("click", function (event) {
    if (
      $(event.target).hasClass("side-cart-overly-wrap") ||
      $(event.target).hasClass("close-icon-wrap") ||
      $(event.target).closest(".close-icon-wrap").length > 0 // this ensures inner clicks still count
    ) {
      $(".open-side-cart").removeClass("open-side-cart");
    }
  });

  $(".send-to-btn").on("click", function () {
    $(".side-cart-body-wrap-2").addClass("open-side-cart-body-wrap-2");
  });
  $(".side-cart-body-wrap-2 .back-to-shipping-link").on(
    "touchend click",
    function (event) {
      if ($(event.target).hasClass("back-to-shipping-link")) {
        $(".open-side-cart-body-wrap-2").removeClass(
          "open-side-cart-body-wrap-2",
        );
      }
    },
  );

  $(".genrate-link").on("click", function () {
    // $(".side-cart-body-wrap-3").addClass("open-side-cart-body-wrap-3");
    generateLink(); // defined on aja-cart.js
  });
  $(".side-cart-body-wrap-3 .back-to-shipping-link").on(
    "touchend click",
    function (event) {
      if ($(event.target).hasClass("back-to-shipping-link")) {
        $(".open-side-cart-body-wrap-3").removeClass(
          "open-side-cart-body-wrap-3",
        );
      }
    },
  );

  $("#custom_add_to_cart").click(function () {
    var interval = 0;
    interval = setInterval(updateText, 100);
    function updateText() {
      var elemText = $("#custom_add_to_cart").text();
      if (elemText == "Adding...") {
        fetchCart(); // This now includes cart title count update
        $(".site-header__cart").click();
        clearInterval(interval);
      }
    }
  });

  let calendlyLink =
    "https://calendly.com/heloiseetabelard/?hide_landing_page_details=1&primary_color=fa8d74";

  // English and French text toggle

  if (typeof window.Weglot !== "undefined") {
    Weglot.on("initialized", updateTranslations);
    Weglot.on("languageChanged", updateTranslations);

    function translateHulkapp() {
      const name = $(".custom-option-name .name.text-fr").text();
      const options = [];

      if (
        !$(".hulkapps_option_child p.text-en").text() &&
        !$(".custom-option-name .name.text-en").text()
      ) {
        $(".hulkapps_option_child p.text-fr").each(function (index, element) {
          const word = $(element).text();
          options.push({
            t: 1,
            w: word,
          });
        });
        options.unshift({
          t: 1,
          w: name,
        });

        Weglot.translate(
          {
            words: options,
            languageTo: "en",
          },
          function (data) {
            if (data) {
              const first = data.shift();
              $(".custom-option-name .name.text-en").text(first);
              $(".hulkapps_option_child p.text-en").each(
                function (index, element) {
                  const colorArray = data[index].split(" ");
                  let color = colorArray[colorArray.length - 1].toLowerCase();
                  const capColor =
                    color.charAt(0).toUpperCase() + color.slice(1);
                  $(element).text(capColor);
                },
              );
            }
          },
        );
      }
    }

    function updateTranslations() {
      const currentLang = window.Weglot.getCurrentLang();

      if (currentLang === "en") {
        // calendlyLink = "https://calendly.com/heloiseetabelard/test-event-type-en?hide_landing_page_details=1&primary_color=fa8d74"
        // initCalendly(calendlyLink)
        $(".remove-link").text("Remove");
        $(".empty_cart").text("The cart is empty");
        if (typeof translateCartDrawerOptions === "function") {
          translateCartDrawerOptions(document);
        }
        // Switching to English Alma wrapper
        $(".alma-wrapper-fr").css("display", "none");
        $(".alma-wrapper-en").css("display", "block");

        // Trigger language change event for Alma widgets
        window.dispatchEvent(
          new CustomEvent("alma-language-changed", {
            detail: { language: "en" },
          }),
        );
        $("#SiteContainer").removeClass("container-fr");
        $("#SiteContainer").addClass("container-en");
        $(".text-fr").each(function () {
          $(this).hide();
        });
        $(".text-en").each(function () {
          $(this).show();
        });
        // Keep ATC label owned by us (Weglot + size select both fight "Commander").
        if (window.theme && window.theme.strings) {
          window.theme.strings.addToCart = "Add to bag";
          window.theme.strings.tryShowroom = "TRY IT ON IN THE SHOWROOM";
          window.theme.strings.bookAppointment = "BOOK AN APPOINTMENT";
        }
        $(".add-to-cart-text-custom")
          .attr("data-wg-notranslate", "")
          .text("Add to bag");
        syncAppointmentCtas("en");
        $(".guide-sidebar-h2-media").text("THE H&A MEDIA");

        const productPage = $("body").hasClass("template-product");

        if (
          window.hulkapps &&
          $(".hulkapps_option_name").length > 0 &&
          productPage
        ) {
          var optionChild = $(this).find(".hulkapps_option_child");
          if (optionChild.find($("p"))) {
            translateHulkapp();
          }
        }
      } else {
        // calendlyLink = "https://calendly.com/heloiseetabelard/test-event-type?hide_landing_page_details=1&primary_color=fa8d74"
        // initCalendly(calendlyLink)
        // $(".remove-link").text("Supprimer");
        $(".empty_cart").text("Le panier est vide");
        if (typeof translateCartDrawerOptions === "function") {
          translateCartDrawerOptions(document);
        }
        // Switching to French Alma wrapper
        $(".alma-wrapper-en").css("display", "none");
        $(".alma-wrapper-fr").css("display", "block");

        // Trigger language change event for Alma widgets
        window.dispatchEvent(
          new CustomEvent("alma-language-changed", {
            detail: { language: "fr" },
          }),
        );
        $("#SiteContainer").removeClass("container-en");
        $("#SiteContainer").addClass("container-fr");
        $(".text-en").each(function () {
          $(this).hide();
        });
        $(".text-fr").each(function () {
          $(this).show();
        });
        if (window.theme && window.theme.strings) {
          window.theme.strings.addToCart = "Commander";
          window.theme.strings.tryShowroom = "ESSAYER AU SHOWROOM";
          window.theme.strings.bookAppointment = "PRENDRE RENDEZ-VOUS";
        }
        $(".add-to-cart-text-custom")
          .attr("data-wg-notranslate", "")
          .text("COMMANDER");
        syncAppointmentCtas("fr");
        $(".guide-sidebar-h2-media").text("LE MÉDIA H&A");
      }
    }

    function syncAppointmentCtas(lang) {
      var isEn = lang === "en";
      var tryLabel = isEn
        ? "TRY IT ON IN THE SHOWROOM"
        : "ESSAYER AU SHOWROOM";
      var bookLabel = isEn
        ? "BOOK AN APPOINTMENT"
        : "PRENDRE RENDEZ-VOUS";

      // Header RDV
      $(".header-rdv-button")
        .attr("data-wg-notranslate", "")
        .text(bookLabel);

      // Side cart showroom CTA
      $(".side-cart .open-contact")
        .attr("data-wg-notranslate", "")
        .text(tryLabel);

      // Regular PDP showroom CTA
      $(".appointment-cta .custom-translation-rdv:not(.custom-translation-rdv-on-demand)")
        .attr("data-wg-notranslate", "")
        .text(tryLabel);

      // On-demand: book when ATC hidden, else try showroom
      $(".appointment-cta .custom-translation-rdv-on-demand").each(function () {
        var $btn = $(this);
        var $atc = $btn
          .closest(".appointment-cta")
          .parent()
          .find("[data-add-to-cart]")
          .first();
        var useBook = $atc.length && $atc.is(":hidden");
        $btn
          .attr("data-wg-notranslate", "")
          .text(useBook ? bookLabel : tryLabel);
      });
    }

    const productPage = $("body").hasClass("template-product");
    var optionCheck = setInterval(function () {
      if (
        productPage &&
        window.hulkapps &&
        $(".hulkapps_option_name").length > 0
      ) {
        var optionChild = $(this).find(".hulkapps_option_child");
        if (optionChild.find($("p"))) {
          clearInterval(optionCheck);
          updateTranslations();
        }
      }
    }, 500);

    if (productPage) {
      setTimeout(function () {
        updateTranslations();
      }, 1000);
    }
  }

  function initCalendly(localizedLink) {
    $(".calendly-appointment-gem-btn").click(function () {
      Calendly.initPopupWidget({ url: localizedLink });
      return false;
    });

    $("a[href$='https://heloise-abelard.reservio.com/'].gf_button").click(
      function () {
        Calendly.initPopupWidget({ url: localizedLink });
        return false;
      },
    );
  }

  initCalendly(calendlyLink);

  // Update side cart max-height on window resize
  $(window).on("resize", function () {
    if ($(".side-cart-main-wrap").hasClass("open-side-cart")) {
      updateSideCartMaxHeight();
    }
  });

  //Amending Alma widget popup text content

  var productSection = $("#shopify-section-product");
  var productOnDemandSection = $("#shopify-section-product-on-demand");

  if (
    (productSection && productSection.length > 0) ||
    (productOnDemandSection && productOnDemandSection.length > 0)
  ) {
    var almaFrCheck = setInterval(function () {
      if (
        ($("#alma-widget-cart-fr") && $("#alma-widget-cart-fr").length > 0) ||
        ($("#alma-widget-product-fr") &&
          $("#alma-widget-product-fr").length > 0)
      ) {
        clearInterval(almaFrCheck);
        $("#alma-widget-cart-fr, #alma-widget-product-fr")
          .children(".alma-payment-plans-container")
          .on("click", function () {
            if ($(".container-fr").length > 0) {
              // Use a more React-friendly approach with error handling
              try {
                const modalPortal = document.querySelector(".ReactModalPortal");
                if (modalPortal && modalPortal.parentNode) {
                  modalPortal.style.visibility = "hidden";
                  setTimeout(function () {
                    try {
                      const titleElement = document.querySelector(
                        ".alma-eligibility-modal-title",
                      );
                      if (titleElement && titleElement.parentNode) {
                        titleElement.innerHTML =
                          "<span>Payez en plusieurs fois</span> par carte bancaire avec Alma.";
                      }

                      const stepElements = document.querySelectorAll("._1HqCO");
                      stepElements.forEach(function (element, index) {
                        if (element && element.parentNode) {
                          const contentDiv =
                            element.querySelector("div:nth-child(2)");
                          if (contentDiv && contentDiv.parentNode) {
                            if (index === 0) {
                              contentDiv.innerHTML =
                                "Choisissez <strong>Alma</strong> au moment du paiement.";
                            } else if (index === 1) {
                              contentDiv.innerHTML =
                                "Renseignez les <strong>informations</strong> de paiement demandées.";
                            } else if (index === 2) {
                              contentDiv.innerHTML =
                                "La validation de votre paiement est <strong>instantané</strong> et votre commande confirmée.";
                            } else if (index > 2) {
                              element.style.display = "none";
                            }
                          }
                        }
                      });

                      if (modalPortal && modalPortal.parentNode) {
                        modalPortal.style.visibility = "visible";
                      }
                    } catch (innerError) {
                      // Error updating Alma modal content
                    }
                  }, 200);
                }
              } catch (error) {
                console.warn("Error accessing React Modal Portal:", error);
              }
            }
          });
      }
    }, 500);

    // Set a timeout to prevent infinite checking for French widgets
    setTimeout(() => clearInterval(almaFrCheck), 10000);

    var almaEnCheck = setInterval(function () {
      if (
        ($("#alma-widget-cart-en") && $("#alma-widget-cart-en").length > 0) ||
        ($("#alma-widget-product-en") &&
          $("#alma-widget-product-en").length > 0)
      ) {
        clearInterval(almaEnCheck);
        $("#alma-widget-cart-en, #alma-widget-product-en")
          .children(".alma-payment-plans-container")
          .on("click", function () {
            if ($(".container-en").length > 0) {
              // Use a more React-friendly approach with error handling
              try {
                const modalPortal = document.querySelector(".ReactModalPortal");
                if (modalPortal && modalPortal.parentNode) {
                  modalPortal.style.visibility = "hidden";
                  setTimeout(function () {
                    try {
                      const titleElement = document.querySelector(
                        ".alma-eligibility-modal-title",
                      );
                      if (titleElement && titleElement.parentNode) {
                        titleElement.innerHTML =
                          "<span>Pay in 2/3 installments</span> by credit card with Alma.";
                      }

                      const stepElements = document.querySelectorAll("._1HqCO");
                      stepElements.forEach(function (element, index) {
                        if (element && element.parentNode) {
                          const contentDiv =
                            element.querySelector("div:nth-child(2)");
                          if (contentDiv && contentDiv.parentNode) {
                            if (index === 0) {
                              contentDiv.innerHTML =
                                "Choose <strong>Alma</strong> at checkout.";
                            } else if (index === 1) {
                              contentDiv.innerHTML =
                                "Fill in the <strong>payment information</strong> requested.";
                            } else if (index === 2) {
                              contentDiv.innerHTML =
                                "Validation of your payment is <strong>instantaneous and your order confirmed.</strong>";
                            } else if (index > 2) {
                              element.style.display = "none";
                            }
                          }
                        }
                      });

                      if (modalPortal && modalPortal.parentNode) {
                        modalPortal.style.visibility = "visible";
                      }
                    } catch (innerError) {
                      // Error updating Alma modal content
                    }
                  }, 200);
                }
              } catch (error) {
                console.warn("Error accessing React Modal Portal:", error);
              }
            }
          });
      }
    }, 500);

    // Set a timeout to prevent infinite checking for English widgets
    setTimeout(() => clearInterval(almaEnCheck), 10000);
  }
});
